// libs
import React from 'react';
import {useTranslation} from "react-i18next";

const Notice24H = (props) => {
    const { t } = useTranslation();
    return (
        <div className="message message--info">
            <div className="message__icon">
                <i className="fas fa-clock"></i>
            </div>
            <div className="message__content">
                <div>
                    {props.text ? props.text : t('account.cards.management.24hour_notice')}
                </div>
            </div>
        </div>
    );
};

export default Notice24H;
